import type { FC } from 'react';
import React from 'react';
import { connect } from 'react-redux';

import ExtraItem from '../../../../../components/ExtraInsurance/components/ExtraItem';
import { originalSelectedExtrasSelector } from '../../../../../store/selectors/services';

import type { IExtraItems } from './types';

const ExtraItems: FC<IExtraItems> = ({
  title,
  extras,
  selectedExtras,
  onToggle,
}) => (
  <div className="checkout-service-items checkout-service-block">
    <h2 className="like-h2">{title}</h2>
    <ul>
      {extras.map((extra) => (
        <ExtraItem
          key={extra.name}
          {...extra}
          selected={Boolean(
            selectedExtras.find(
              (selectedExtra) => selectedExtra.hashsum === extra.hashsum,
            ),
          )}
          onChange={onToggle}
        />
      ))}
    </ul>
  </div>
);

const mapStateToProps = (state) => ({
  selectedExtras: originalSelectedExtrasSelector(state),
});

export default connect(mapStateToProps)(ExtraItems);
